import NewsletterWidget from "./NewsletterWidget";
import { FooterBrand } from "./footer/FooterBrand";
import { FooterLinks } from "./footer/FooterLinks";
import { FooterCities } from "./footer/FooterCities";
import { FooterMoreCities } from "./footer/FooterMoreCities";
import { FooterLatamCities } from "./footer/FooterLatamCities";
import { FooterContact } from "./footer/FooterContact";
import { FooterBottom } from "./footer/FooterBottom";
import { FooterGTranslate } from "./footer/FooterGTranslate";
import { AdminOnlineTracker } from "./admin/AdminOnlineTracker";
import {
  discoverLinks,
  professionalsLinks,
  landingPagesLinks,
  legalLinks,
} from "./footer/footerData";

const Footer = () => {
  return (
    <footer className="bg-card border-t py-12">
      <div className="container mx-auto px-4">
        {/* Newsletter Widget */}
        <div className="mb-12">
          <NewsletterWidget />
        </div>
        
        {/* Main Links Section - Row 1 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <FooterBrand />
          <FooterLinks title="Descubre" links={discoverLinks} />
          <FooterLinks title="Para Profesionales" links={professionalsLinks} />
          <FooterLinks title="Legal" links={legalLinks} />
        </div>

        {/* Second Row - Cities and Services */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 border-t pt-8 mb-8">
          <FooterCities />
          <FooterMoreCities />
          <FooterLatamCities />
          <FooterLinks title="Nuestros Servicios" links={landingPagesLinks} />
        </div>

        {/* Contact Section */}
        <div className="border-t pt-8">
          <FooterContact />
        </div>
        
        <FooterGTranslate />
        <FooterBottom />
        <AdminOnlineTracker />
      </div>
    </footer>
  );
};

export default Footer;
